import { PlatformFeature } from '../models/platform-feature.model';

export const PLATFORM_FEATURES: PlatformFeature[] = [
  {
    icon: '📚',
    title: 'Interactive Learning',
    description: 'Access engaging lessons, interactive content, and multimedia resources designed to enhance your learning experience and academic success.'
  },
  {
    icon: '📊',
    title: 'Progress Tracking',
    description: 'Monitor your academic progress with detailed analytics, grade tracking, and personalized insights to help you excel in your studies.'
  },
  {
    icon: '👨‍🏫',
    title: 'Expert Teachers',
    description: 'Learn from qualified, experienced teachers who provide personalized guidance and support throughout your educational journey.'
  },
  {
    icon: '📱',
    title: 'Mobile Learning',
    description: 'Study anywhere, anytime with our mobile-friendly platform that keeps you connected to your education on any device.'
  },
  {
    icon: '🎯',
    title: 'Personalized Learning',
    description: 'Receive customized learning paths and recommendations tailored to your learning style, pace, and academic goals.'
  },
  {
    icon: '🏆',
    title: 'Achievement System',
    description: 'Earn badges, certificates, and recognition for your accomplishments while staying motivated on your learning journey.'
  }
];
